
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'Errors',
  computed: {
    ...mapState([ 'errors', 'appInfo' ]),
    title() {
      if (this.errorType === 'object' && this.errors && this.errors.title) {
        return this.errors.title
      }
      if (this.appInfo['global_error']) {
        return this.appInfo['global_error'].title
      }
      return 'Error!'
    },
    cta() {
      if (this.appInfo['global_error']) {
        return this.appInfo['global_error'].cta
      }
      return 'Ok'
    },
    errorType() {
      if (this.errors) {
        if (Array.isArray(this.errors)) {
          return 'array'
        } else if (typeof this.errors === 'string') {
          return 'string'
        } else if (typeof this.errors === 'object') {
          return 'object'
        }
      }
      return ''
    },
    errorList() {
      if (this.errorType === 'array') {
        return this.errors
      }
      if (this.errorType === 'string') {
        return [this.errors]
      }
      if (this.errorType === 'object') {
        return [this.errors.message]
      }

      return []
    },
    showCustomActions() {
      if (this.errorType === 'object') {
        return this.errors && this.errors.actions && this.errors.actions.length > 0
      }
      return false
    },
  },
  methods: {
    ...mapMutations([ 'setErrors' ]),
    closeErrors() {
      this.setErrors([ ])
    },
  }
}
